import PropTypes from 'prop-types';
import React, { useState } from 'react';

const WizardStep = props => {
  const { children, ...rest } = props;

  const isReactComponent = ({ type }) =>
    typeof type === 'function' || typeof type === 'object';

  const isChildrenFunction = value => typeof value === 'function';

  if (isReactComponent(children) && React.isValidElement(children)) {
    return React.cloneElement(children, { ...rest });
  } else if (isChildrenFunction(children) && !React.isValidElement(children)) {
    return children({ ...rest });
  } else {
    return children;
  }
};

WizardStep.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  name: PropTypes.string.isRequired
};

const WizardStepper = props => {
  const { children, activeStep } = props;

  const childrenArray = React.Children.toArray(children);
  const [currentStep, setCurrentStep] = useState(activeStep);
  const currentChild = childrenArray[currentStep];

  const nextStep = () => {
    if (currentStep < childrenArray.length - 1) {
      setCurrentStep(prev => prev + 1);
    }
  };

  const previousStep = () => {
    if (currentStep > 0) {
      setCurrentStep(prev => prev - 1);
    }
  };

  const goToStep = stepNumber => {
    const isTypeNumber = typeof stepNumber === 'number';

    if (
      isTypeNumber &&
      stepNumber >= 0 &&
      stepNumber < childrenArray.length
    ) {
      setCurrentStep(Math.floor(stepNumber));
    }
  };

  return React.cloneElement(currentChild, { nextStep, previousStep, goToStep });
};

WizardStepper.propTypes = {
  children: PropTypes.node.isRequired,
  activeStep: PropTypes.number
};

WizardStepper.defaultProps = {
  activeStep: 0
};

export { WizardStepper, WizardStep };
